var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.598 14.2448C33.4639 14.2265 33.3297 14.2265 33.1955 14.2448C30.2247 14.1532 27.8672 11.8248 27.8672 8.96484C27.8672 6.04984 30.3397 3.6665 33.4064 3.6665C36.4539 3.6665 38.9455 6.0315 38.9455 8.96484C38.9264 11.8248 36.5689 14.1532 33.598 14.2448Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8511 26.9507C37.7045 28.3257 34.6953 28.8391 31.9161 28.4907C32.6445 26.9874 33.0278 25.3191 33.047 23.5591C33.047 21.7257 32.6253 19.9841 31.8203 18.4624C34.657 18.0957 37.6661 18.6091 39.832 19.9841C42.8603 21.8907 42.8603 25.0257 39.8511 26.9507Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.344 14.2448C12.4781 14.2265 12.6123 14.2265 12.7465 14.2448C15.7173 14.1532 18.0748 11.8248 18.0748 8.96484C18.0748 6.0315 15.6023 3.6665 12.5356 3.6665C9.48812 3.6665 7.01562 6.0315 7.01562 8.96484C7.01562 11.8248 9.37312 14.1532 12.344 14.2448Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5566 23.5594C12.5566 25.3378 12.9591 27.0244 13.6874 28.5461C10.9849 28.8211 8.16742 28.2711 6.09742 26.9694C3.06909 25.0444 3.06909 21.9094 6.09742 19.9844C8.14826 18.6644 11.0424 18.1327 13.7641 18.4261C12.9783 19.9661 12.5566 21.7078 12.5566 23.5594Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2312 29.095C23.0779 29.0767 22.9054 29.0767 22.7329 29.095C19.2062 28.985 16.3887 26.2167 16.3887 22.8067C16.4078 19.3233 19.3404 16.5 23.0012 16.5C26.6429 16.5 29.5945 19.3233 29.5945 22.8067C29.5754 26.2167 26.777 28.985 23.2312 29.095Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0027 32.8913C14.1085 34.743 14.1085 37.7863 17.0027 39.6196C20.2994 41.728 25.7044 41.728 29.001 39.6196C31.8952 37.768 31.8952 34.7246 29.001 32.8913C25.7235 30.783 20.3185 30.783 17.0027 32.8913Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople1);
export default __webpack_public_path__ + "static/media/people 1.914824721e7f0f885967377942a811f2.svg";
export { ForwardRef as ReactComponent };